import { DraftReturnSchema } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const cloneDraftReturnExcludingItems = {
  name: "cloneDraftReturnExcludingItems" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    excludedReturnableItemIds: z.array(z.string()),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
